var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-view"},[_c('MusicPlayer',{attrs:{"mode":_vm.mode,"styles":_vm.musicPlayerStyles,"songs":_vm.audios},on:{"new-songs":_vm.updateSongs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }